import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';

type Props = {
  formComposition: FormCompositionHook<'aimWorkloads'>;
};

export const AimWorkloadsSubTab = ({ formComposition }: Props) => (
  <div className='flex flex-col flex-1 gap'>
    {formComposition.renderGroup('aimWorkloads')}
  </div>
);
